query GetTotalPriceSunProtection(
    $dealId: Long!
    $productInputs: [SunProtectionProductInput!]!
    $discountCode: String
) {
    getTotalPriceSunProtection(
        dealId: $dealId
        productInputs: $productInputs
        discountCode: $discountCode
    ) {
        products {
            product {
                id
            }
            sunProtectionProductId
            colorId
            total {
                netAmount
                valueAddedTax
                grossAmount
                discountedNetAmount
                discountedValueAddedTax
                discountedGrossAmount
            }
        }
        productsTotals {
            netAmount
            valueAddedTax
            grossAmount
            discountedNetAmount
            discountedValueAddedTax
            discountedGrossAmount
        }
        productSurfaces {
            productId
            surface {
                area
                areaType
            }
            count
        }
        totalSurface {
            area
            areaType
        }
    }
}
